import { gsap } from "gsap"
import { ScrollTrigger } from 'gsap/ScrollTrigger'

// TODO: set config values as parameter
export const useGSAP = () => {
	gsap.registerPlugin(ScrollTrigger)

	gsap.config({
		autoSleep: 80,
		force3D: false,
		nullTargetWarn: false,
		units: { left: "%", top: "%", rotation: "rad" },
	});

	ScrollTrigger.defaults({
		toggleActions: 'play none none none',
		scroller: 'body',
		scrub: false,
		pin: false,
		markers: false,
		invalidateOnRefresh: true,
	})
	return { gsap, ScrollTrigger }
}
